import Model from "../Model.js"


export default class NfcValueLabel extends Model {
    constructor() {
        super("nfcvaluelabel", "api")
      }

    defaultValues() {
        return {
            id: 0,
            value: 0,
        }
    }

}


